export default "// Get your new account on NEAR testnet and replace the placeholder it with your id\n^[a-z0-9_-]*.testnet\n";